import { Action, Reducer } from "redux";
import { ReportTemplateState, ReportTemplateTypes, ReportTemplateActionTypes } from "./reportTemplateTypes";
import { haskeyReducer, updateGetIsolated, updateSaveIsolated } from "@/main/services/reducerUtils";

export const INITIAL_STATE: ReportTemplateState = {
	reportTemplateDomain: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	isolated: {},
};

const reportTemplateReducer: Reducer<ReportTemplateState> = (
	state: ReportTemplateState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as ReportTemplateActionTypes;
	switch (actionTypes.type) {
		case ReportTemplateTypes.GET_REPORT_TEMPLATE_DOMAIN: {
			const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducer) return updateGetIsolated(state, actionTypes);

			return {
				...state,
				reportTemplateDomain: { ...state.reportTemplateDomain, isLoading: true },
			};
		}
		case ReportTemplateTypes.SAVE_REPORT_TEMPLATE_DOMAIN: {
			const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

			return {
				...state,
				reportTemplateDomain: {
					...state.reportTemplateDomain,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		}
		case ReportTemplateTypes.RESET_REDUCER_REPORT_TEMPLATE:
			return {
				...state,
				reportTemplateDomain: INITIAL_STATE.reportTemplateDomain,
			};
		default:
			return state;
	}
};

export default reportTemplateReducer;
